module.exports = __webpack_public_path__ + "static/media/logo memory.fa3e68ae.png";